import React, { Component } from "react";
import { connect } from "react-redux";
import Tabs from "components/Tabs";
import { refresh as load } from "redux/stat/actions";
import { changeTab as changeRange, changeDates } from "redux/main/actions";
import { refresh as loadBannerplaces } from "redux/site/actions";
import { tabs, getDate, tabIndex } from "redux/helpers";
import { getDates } from "redux/selectors";
import { change, submit } from "redux-form";

class Stat extends Component {
  componentDidMount() {
    const { start, stop, submit } = this.props;
    this.loadData({ start, stop }).then(() => submit("statForm"));
  }

  clearFields = () => {
    this.props.change("statForm", "bannerPlaces", null);
    this.props.change("statForm", "formats", null);
  };

  componentWillReceiveProps(nextProps) {
    const {
      match: { params: { publisherID: nextPublisherId } },
      start,
      stop
    } = nextProps;
    const { match: { params: { publisherID } } } = this.props;
    if (nextPublisherId !== publisherID) {
      this.loadData({ start, stop, site_id: nextPublisherId });
    }
  }

  onChangeDataPicker = (nothing, data) => {
    const { startDate: start, endDate: stop } = data;
    const { changeDates, submit } = this.props;
    if (start && stop) {
      this.loadData({ start, stop }).then(() => submit("statForm"));
      changeDates({ start, stop });
    }
  };

  loadData = ({ start, stop, ...rest }) => {
    const {
      load,
      loadBannerplaces,
      match: { params: { publisherID: site_id } }
    } = this.props;

    this.clearFields();

    load({ start, stop, name: "total" });
    return loadBannerplaces({
      name: "bannerplaces",
      site_id,
      start,
      stop,
      ...rest
    });
  };

  onChange = activeKey => {
    const { changeRange, submit } = this.props;
    const start = getDate("start", activeKey);
    const stop = getDate("end", activeKey);

    if (start && stop && +activeKey !== tabIndex) {
      this.loadData({ start, stop }).then(() => submit("statForm"));
      changeRange(activeKey);
    }
  };

  render() {
    return (
      <Tabs
        items={tabs}
        value={this.props.currentTab}
        onChange={this.onChange}
        onChangeDataPicker={this.onChangeDataPicker}
      />
    );
  }
}

const mapStateToProps = state => {
  const {
    stat: { type: { bySite: { main: { isFetching } } } },
    main: { currentTab }
  } = state;

  return {
    ...getDates(state),
    currentTab,
    isFetching
  };
};

export default connect(mapStateToProps, {
  load,
  changeRange,
  changeDates,
  loadBannerplaces,
  change,
  submit
})(Stat);
